import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=aad8b99e&scoped=true"
import script from "./Restaurant.vue?vue&type=script&lang=ts"
export * from "./Restaurant.vue?vue&type=script&lang=ts"
import style0 from "./Restaurant.vue?vue&type=style&index=0&id=aad8b99e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad8b99e",
  null
  
)

export default component.exports